/**
 * Leave an expired local session, distinct from explicitly logging out of the identity provider.
 * Confirmed refresh rejection clears server auth cookies before invoking this action; temporary
 * renewal failures must not invoke it. Reload currently discards unsaved UI state.
 * This module should own expiry, explicit logout, and shared local teardown under the policy
 * we choose for canceling work and clearing or retaining local state. Logout and expiry should
 * share that teardown, not call each other: their intent and identity-provider behavior differ.
 * Keeping expiry behind this action lets design/frontend add feedback without changing callers.
 * Consider storing a one-shot enum reason before reload, then consuming it on the login page
 * to display a fixed explanation rather than passing arbitrary messages between pages.
 */
export function expireSession() {
    window.location.reload()
}
